import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect as BasicRedirect, useLocation, Link as BasicLink } from 'react-router-dom'
import {TRANSLATE_LANGUAGES, TRANSLATE_DEFAULT_LANGUAGE} from 'src/common/razzle-platform-translate/configs'


interface LinkProps {
	to: string
	className?: string
	role?: string
    target?: string
}

export const Link: FC<LinkProps> = (props) => {
	const {to, children, className=undefined, role, target } = props
	const locale = useSelector((state: any) => state.translationModel.locale || TRANSLATE_DEFAULT_LANGUAGE)
	
	const path = locale === TRANSLATE_DEFAULT_LANGUAGE || to.substr(0, 4) === `/${locale}/` ? to : `/${locale}${to}`
	return <BasicLink to={path} className={className} {...role ? {role} : null} target={target} >{children}</BasicLink>
}


export const Redirect = ({to}) => {
    const locale = useSelector((state: any) => state.translationModel.locale || TRANSLATE_DEFAULT_LANGUAGE)
	const path = locale === TRANSLATE_DEFAULT_LANGUAGE ? to : `/${locale}${to}`
	return <BasicRedirect to={path} />
}

